import { AnyAction } from "redux";
import { ThunkAction } from "redux-thunk";
import * as AT from "./actionTypes";
import { RootState } from "../../../../models";

export const startNavigating = (path: string) => ({
    type: AT.NAVIGATION_START,
    path,
});

export const endNavigating = (path: string) => ({
    type: AT.NAVIGATION_END,
    path,
});

export const navigate =
    (path: string): ThunkAction<void, RootState, unknown, AnyAction> =>
    async (dispatch) => {
        dispatch(startNavigating(path));
        window.location.assign(path);
    };
